import React from 'react';
import { PostsList } from '../PostsList';
import { Post } from '../Post';
import { PostReply } from '../Post.types';
import IForm from '../../../../types/IForm';

type PostReplies = {
  replies?: PostReply[];
  parentPostNumber: number;
  previousPostId?: string;
  currentForm: IForm | undefined;
  setCurrentForm: (newState: IForm | undefined) => void;
};

export function PostReplies({ replies, parentPostNumber, previousPostId, currentForm, setCurrentForm }: PostReplies) {
  if (!replies || replies.length === 0) {
    return null;
  }

  /**
   * Creating counter for replies like this:
   * "Reply 1.3"
   */
  const getPostNumberForReply = (index: number): string => `${parentPostNumber}.${index + 1}`;

  return (
    <div className="posts__replies">
      <PostsList headingHierarchy={4} type="reply">
        {replies.map((reply, index) => {
          return (
            <Post
              type="reply"
              post={reply}
              postNumber={getPostNumberForReply(index)}
              headingHierarchy={5}
              previousPostId={previousPostId}
              key={reply.id}
              currentForm={currentForm}
              setCurrentForm={setCurrentForm}
            />
          );
        })}
      </PostsList>
    </div>
  );
}
